import { Component, Input } from '@angular/core';
import {Location} from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.css'],
})
export class BackButtonComponent {

  @Input() backUrl: string | null = null;
  constructor(
    private router: Router,
    private location: Location) { }
  goBack() {
    if(this.backUrl == null){      
     history.back();
    }else{
      this.router.navigate([this.backUrl]);
    }
  }
}
